/* ============================================================
   PAGE-HOME — Homepage-scoped behaviour
   ------------------------------------------------------------
   Core behaviour (modals, nav, booking, sticky bar) all live
   in assets/resonance.js which is loaded globally by theme.liquid.
   This file is the hook point for homepage-only additions.

   Currently: no homepage-only behaviour required. The file is
   included so the <script> tag in page-home.liquid has a valid
   target and can be extended without touching the section liquid.
   ============================================================ */

(function() {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     HOMEPAGE — Nav active state
     Mark the homepage nav item active on page load.
     The main initAnchorNav() in resonance.js handles section
     scrolling; this sets the top-level nav item.
     ────────────────────────────────────────────────────────── */
  function initHomeNavActive() {
    var navItems = document.querySelectorAll('.rm-nav-center > li');
    navItems.forEach(function(li) {
      var link = li.querySelector('a');
      if (link && (link.getAttribute('href') === '/' || link.getAttribute('href') === window.location.pathname)) {
        li.classList.add('active');
      }
    });
  }

  /* ──────────────────────────────────────────────────────────
     INIT
     ────────────────────────────────────────────────────────── */
  function init() {
    initHomeNavActive();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
